import { format, parseISO } from 'date-fns';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaUserEdit } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';

import { GridLinkButton } from '../grid/grid-link-button';
import { gql, useApolloClient } from '@apollo/client';

function useGetUserByName() {
  const client = useApolloClient();
  const gqlScript = gql`
    query getQuery($name: String) {
      getUserByName(name: $name) {
        id
        userName
        lastName
        firstName
        email
        tel
        mobile1
        position
        notes
        changePasswordNextTime
        signatureFileId
      }
    }
  `;

  async function getUserByName(name: string): Promise<any> {
    const ret = await client.query({
      query: gqlScript,
      variables: { name },
      fetchPolicy: 'network-only',
    });
    return ret?.data?.getUserByName;
  }

  return { getUserByName };
}

function formatDateTime(dt: any) {
  return format(parseISO(dt), 'dd/MM/yyyy HH:mm');
}

export const UserTooltip = ({ data, auditTable = undefined, auditId = undefined }) => {
  const { t } = useTranslation();
  auditId = auditId ? auditId : data.id;
  const firstDate =
    data?.firstDate !== null && data?.firstDate !== undefined ? formatDateTime(data.firstDate) : '';
  const lastDate =
    data?.lastDate !== null && data?.lastDate !== undefined ? formatDateTime(data.lastDate) : '';

  const { getUserByName } = useGetUserByName();
  const history = useHistory();
  const gotoUser = async (userName: string) => {
    const user = await getUserByName(userName);
    if (user) {
      history.push(`/user/${user.id}`);
    }
  };
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      delay={{ show: 300, hide: 3000 }}
      overlay={
        <Tooltip
          id={`overlay-${data.firstUser}`}
          style={
            {
              '--bs-tooltip-bg': '#3b3f45',
              '--bs-tooltip-max-width': '360px',
            } as React.CSSProperties
          }
        >
          <div
            style={{
              margin: '5px',
              minWidth: '300px',
              backgroundColor: '#3b3f45',
              borderRadius: '6px',
              padding: '6px 8px',
            }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '80px 1fr',
                rowGap: '8px',
                columnGap: '3px',
                alignItems: 'center',
                fontSize: '1.1rem',
                lineHeight: 1.35,
              }}
            >
              <span style={{ fontWeight: 700 }}>{t('Create')}:</span>
              <span>
                {firstDate}
                &nbsp;&nbsp;
                <span
                  onClick={() => gotoUser(data.firstUser)}
                  style={{ cursor: 'pointer', textDecoration: 'underline', color: 'inherit' }}
                >
                  {data.firstUser}
                </span>
              </span>

              <span style={{ fontWeight: 700 }}>{t('Change')}:</span>
              <span>
                {lastDate}
                &nbsp;&nbsp;
                <span
                  onClick={() => gotoUser(data.lastUser)}
                  style={{ cursor: 'pointer', textDecoration: 'underline', color: 'inherit' }}
                >
                  {data.lastUser}
                </span>
              </span>
            </div>
            {auditTable && (
              <h6 className="text-end">
                <AuditTrailLink auditTable={auditTable} auditId={auditId} />
              </h6>
            )}
          </div>
        </Tooltip>
      }
      placement="left"
    >
      <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
        <FaUserEdit size="1.5rem" className="pe-1" />
      </span>
    </OverlayTrigger>
  );
};

export const AuditTrailLink = ({ auditTable = undefined, auditId = undefined }) => {
  const history = useHistory();
  const onClick = () => {
    history.push({
      pathname: '/audit-trails',
      state: { filterValues: { tableRowId: auditId, tableName: auditTable } },
    });
  };
  return <GridLinkButton onClick={onClick}>Audit Trail</GridLinkButton>;
};
